module.exports = __webpack_public_path__ + "static/media/SYSCO_TRUCK.a402c5ef.svg";